export const GENERIC_FAILURE_MESSAGE =
  'Something went wrong while saving. Please try again, or contact Team Dalyan if the problem persists.';

// Reads a 400 body defensively: `AccommodationBlockingController` write endpoints return a plain
// BadRequest(ex.Message), but model-binding failures on an [ApiController] can instead return a
// JSON ProblemDetails body ({ title, errors }). Falls back to the raw text, then a generic message.
// Shared by all Accommodation Blocking write thunks (see docs/adr/0008).
export async function parseViolationMessages(response: Response): Promise<string[]> {
  const text = await response.text();

  if (!text) {
    return [GENERIC_FAILURE_MESSAGE];
  }

  try {
    const data: unknown = JSON.parse(text);

    if (typeof data === 'string' && data.trim().length > 0) {
      return [data];
    }

    if (data && typeof data === 'object') {
      const problemDetails = data as { errors?: Record<string, string[]>; title?: string };

      if (problemDetails.errors) {
        const messages = Object.values(problemDetails.errors).flat();
        if (messages.length > 0) {
          return messages;
        }
      }

      if (problemDetails.title) {
        return [problemDetails.title];
      }
    }

    return [GENERIC_FAILURE_MESSAGE];
  } catch {
    return [text];
  }
}
